import { LAT_MAX, LNG_MAX } from './parse-coordinates';
import type { Coordinates } from './parse-coordinates';

/**
 * Derives an initial map marker from `lat`/`lng` URL search params. Returns the
 * coordinate pair only when both values are finite numbers within valid ranges
 * (latitude [-90, 90], longitude [-180, 180]); otherwise returns null so junk or
 * absent params never render a marker. Used to seed a marker when the map is
 * opened by coordinates (catalog "open on map" and POI "show on map").
 */
export function urlLatLngToMarker(
  lat: number | undefined,
  lng: number | undefined,
): Coordinates | null {
  if (lat === undefined || lng === undefined) return null;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > LAT_MAX || Math.abs(lng) > LNG_MAX) return null;
  return { lat, lng };
}
